const $758bf2b4e0921a4d$var$cdnUrl = new URL("https://cdn.nuffle.me");
const $758bf2b4e0921a4d$export$d59684bd6812eef8 = (path)=>new URL(path, $758bf2b4e0921a4d$var$cdnUrl);


const $28aaa950a8ccff4e$var$avatars = [
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar1.png"),
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar2.png"),
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar3.png"),
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar4.png"),
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar5.png"),
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar6.png"),
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar7.png"),
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar8.png"),
    (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/avatar/avatar9.png")
];
const $28aaa950a8ccff4e$export$913078032f14f7f = ()=>{
    const randomIndex = Math.floor(Math.random() * $28aaa950a8ccff4e$var$avatars.length);
    return $28aaa950a8ccff4e$var$avatars[randomIndex];
};
const $28aaa950a8ccff4e$export$887d90529fed91fb = (currentAvatar)=>{
    const currentIndex = $28aaa950a8ccff4e$var$avatars.indexOf(currentAvatar);
    const nextIndex = (currentIndex + 1) % $28aaa950a8ccff4e$var$avatars.length;
    return $28aaa950a8ccff4e$var$avatars[nextIndex];
};



const $45d4c8ff0b5c93f1$export$95fd5664a53dd0c5 = (key)=>{
    return localStorage.getItem(`queryParam_${key}`) ?? null;
};
const $45d4c8ff0b5c93f1$export$850a80245f7240a5 = (key, value)=>{
    const param = $45d4c8ff0b5c93f1$export$95fd5664a53dd0c5(key);
    if (!param) return false;
    return value === undefined ? true : param === value;
};
const $45d4c8ff0b5c93f1$export$cda26142bf6971e9 = (key)=>{
    localStorage.removeItem(`queryParam_${key}`);
};
const $45d4c8ff0b5c93f1$export$727f487d81e2c5cc = ()=>{
    if (!window?.location?.search) return;
    // Store each query parameter in localStorage
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key)=>{
        localStorage.setItem(`queryParam_${key}`, value);
    });
    // Remove query parameters from the URL without reloading the page
    const newUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
};


const $33c207c60b913071$var$navTiles = [
    {
        name: "Plushie Party",
        href: "https://t.me/+uzaCc2MrNEozMDBh",
        image: new URL("https://i.giphy.com/Vt4wDrLAnH1tu.webp"),
        eventName: "nav.party-invite",
        label: "\uD83C\uDF8A Plushie Party Invite! \uD83C\uDF89 (CFF 2026)",
        className: "nav-special",
        addDivider: true,
        condition: ()=>(0, $45d4c8ff0b5c93f1$export$850a80245f7240a5)("plushie", "true")
    },
    {
        name: "dsts-viewer",
        href: "https://nuffle.me/dsts-viewer/",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/dsts.png"),
        eventName: "nav.dsts-viewer",
        label: "Digimon Story: Time Stranger - Model Viewer"
    },
    {
        name: "Tangled",
        href: "https://tangled.org/nuffle.me",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/tangled.jpeg"),
        eventName: "nav.tangled",
        label: "@nuffle.me on Tangled"
    },
    {
        name: "Ko-fi",
        href: "https://ko-fi.com/nuffle",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/kofi.png"),
        eventName: "nav.ko-fi",
        label: "nuffle on Ko-fi",
        addDivider: true
    },
    // {
    //   name: "Dolphinspired Studio",
    //   href: "https://dolphinspired.com",
    //   image: cdn("site/logo/dolphinspired.png"),
    //   eventName: "nav.dolphinspired-studio",
    //   label: "dolphinspired.com - My Studio & Store!",
    // },
    // {
    //   name: "Instagram",
    //   href: "https://www.instagram.com/dolphinspired/",
    //   image: cdn("site/logo/instagram.png"),
    //   eventName: "nav.instagram",
    //   label: "@dolphinspired on Instagram",
    //   addDivider: true,
    // },
    {
        name: "Bluesky",
        href: "https://bsky.app/profile/nuffle.me",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/bluesky.png"),
        eventName: "nav.bluesky",
        label: "@nuffle.me on Bluesky"
    },
    {
        name: "Telegram",
        href: "https://t.me/dolphinspired",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/telegram.png"),
        eventName: "nav.telegram",
        label: "@dolphinspired on Telegram"
    },
    {
        name: "Discord",
        href: "https://discord.com/users/263732939815256064",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/discord.png"),
        eventName: "nav.discord",
        label: "@dolphinspired on Discord"
    },
    {
        name: "Toyhouse",
        href: "https://toyhou.se/25234327.nuffle-emberdrake",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/toyhouse.png"),
        eventName: "nav.toyhouse",
        label: "Nuffle on Toyhouse"
    },
    {
        name: "Furtrack",
        href: "https://www.furtrack.com/index/character:nuffle",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/furtrack.png"),
        eventName: "nav.furtrack",
        label: "Nuffle on Furtrack"
    },
    {
        name: "Github",
        href: "https://github.com/dolphinspired",
        image: (0, $758bf2b4e0921a4d$export$d59684bd6812eef8)("site/logo/github.png"),
        eventName: "nav.github",
        label: "dolphinspired on Github"
    }
];
const $33c207c60b913071$export$455da197c7796fd9 = ()=>{
    return $33c207c60b913071$var$navTiles.filter((item)=>item.condition ? item.condition() : true).map((item)=>{
        let content = `
<div class="page-item-wrap relative ${item.className ?? ""}">
  <div class="page-item flex-both-center absolute"></div>
  <a target="_blank" class="page-item-each py-10 flex-both-center" href="${item.href}" data-umami-event="${item.eventName}">
    <img class="link-each-image" src="${item.image}" alt="${item.name}"/>
    <span class="item-title text-center">${item.label}</span>
  </a>
</div>
`;
        if (item.addDivider) content = content + `<hr />`;
        return content;
    }).join("");
};



const $b4e14b6b8da86996$var$onload = ()=>{
    (0, $45d4c8ff0b5c93f1$export$727f487d81e2c5cc)();
    const metrics = window.umami;
    const navTilesContainer = document.getElementById("navTiles");
    if (navTilesContainer) navTilesContainer.innerHTML = (0, $33c207c60b913071$export$455da197c7796fd9)();
    let currentImage = (0, $28aaa950a8ccff4e$export$913078032f14f7f)();
    const profileImage = document.getElementById("profile-image");
    const sqek = document.getElementById("sqek");
    if (profileImage) {
        profileImage.src = currentImage.href;
        profileImage.onclick = ()=>{
            const nextImage = (0, $28aaa950a8ccff4e$export$887d90529fed91fb)(currentImage);
            currentImage = nextImage;
            profileImage.src = nextImage.href;
            if (sqek) sqek.play().catch((error)=>{
                console.error("Error playing sound:", error);
            });
            if (metrics) metrics.track("avatar-squeaked");
        };
    }
    const queryParamFrom = (0, $45d4c8ff0b5c93f1$export$95fd5664a53dd0c5)("from");
    if (metrics && queryParamFrom) {
        metrics.track(`from.${queryParamFrom}`);
        (0, $45d4c8ff0b5c93f1$export$cda26142bf6971e9)("from");
    }
};
if (document) document.addEventListener("DOMContentLoaded", $b4e14b6b8da86996$var$onload);


//# sourceMappingURL=nuffle.me.81f0547f.js.map
